import { Component } from '@angular/core';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

@Component({
  selector: 'pwj-mega-menu-skeleton',
  imports: [NgxSkeletonLoaderModule],
  templateUrl: './mega-menu-skeleton.component.html',
  styleUrl: './mega-menu-skeleton.component.scss',
})
export class MegaMenuSkeletonComponent {}
